'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var SelectableCard = require('../../components/SelectableCard.js');
var index = require('../../components/Icon/index.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ItemSelectionProvider = require('./ItemSelectionProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TagContent = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", null, content, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "CheckMark",
    width: "11",
    height: "11",
    style: {
      marginLeft: '8px'
    },
    role: "presentation"
  }));
};
const ItemSelectionSelectableCard = _ref2 => {
  let {
    item,
    packageId,
    children,
    ...rest
  } = _ref2;
  const {
    handleItemSelection,
    itemClaims
  } = ItemSelectionProvider.useItemSelection();
  const {
    claimsTagAdded
  } = nthHookTranslations.useTranslations();
  const claimDetails = itemClaims[`${item.itemRefId}_${packageId}`];
  const isSelected = Boolean(claimDetails);
  return /*#__PURE__*/React__default["default"].createElement(SelectableCard["default"], _extends__default["default"]({
    onClick: () => handleItemSelection({
      itemUid: item.itemRefId,
      packageId
    }),
    tagProps: isSelected ? {
      tagContent: /*#__PURE__*/React__default["default"].createElement(TagContent, {
        content: claimsTagAdded ?? ''
      })
    } : undefined
  }, rest), children);
};
var ItemSelectionSelectableCard$1 = nthHookTranslations.withTranslationsProvider(ItemSelectionSelectableCard, {
  translationKeys: ['claimsTagAdded']
});

exports["default"] = ItemSelectionSelectableCard$1;
